module.exports = __webpack_public_path__ + "media/כתבה.08ac0e38.mp3";